import React from "react";
import StepIndicator from "./step-indicator/StepIndicator";
import {FormSectionElements } from "../../entities/formTemplateDataType";
import { ErrorAlertComponent } from "../odsCalloutBox/ErrorAlertComponent";
import FeedbackComponent from "./FeedbackComponent";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
    //programContainer: ProgramContainer;
    field: FormSectionElements;
    isEng: boolean;
    code?: string;
    // Visible: boolean;
    callback,
}

export class TechErrorComponent extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

    }

    render() {
        // if (!this.props.Visible) return null;

        const profile = this.props.field.parent.parent.parent.Profile;
        let backToLabel;
        let backToUrl;
        const body = this.props.isEng ? this.props.field.ErrorContentValue ? this.props.field.ErrorContentValue : "The service is currently unavailable."
            : this.props.field.ErrorContentValueFRA ? this.props.field.ErrorContentValueFRA : "Le service est actuellement indisponible."
        if (!profile) {
            backToLabel = this.props.isEng ? "Back to Ontario.ca" : "Revenir à Ontario.ca";
            backToUrl = "https://www.ontario.ca/page/serviceontario";

        } else {
           backToLabel = this.props.isEng ? "Back to home" : "Retour à l'accueil";
            backToUrl = this.props.isEng ? process.env.CXP_URL : process.env.CXP_URL_F;
        }
         
        let feedbackUrl;

        if (profile) {
            feedbackUrl = this.props.isEng ? process.env.FEEDBACK_URL_CXP_USER : process.env.FEEDBACK_URL_CXP_USER_F;
         } else {
            feedbackUrl = this.props.isEng ? process.env.FEEDBACK_URL_NO_CXP_USER : process.env.FEEDBACK_URL_NO_CXP_USER_F;
        }

        const HtmlToReactParser = require('html-to-react').Parser;
        const htmlToReactParser = new HtmlToReactParser();
        const reactElement = htmlToReactParser.parse(this.props.isEng ? this.props.field.Value : this.props.field.ValueFRA);
        const programContainer =getRootComponent(this.props.field);

        return (
            <div>
                <div>
                    {profile?.email && (
                        <StepIndicator withbackbtn={true} sectionSequence={0} title={backToLabel} programContainer={programContainer}
                            isEng={this.props.isEng} isTechicalErrorPage={true}
                            callback={(currentStep) => { this.setState({ stepperIndex: currentStep }) }}>
                        </StepIndicator>
                    )}
                    {!profile?.email && (
                        <StepIndicator withbackbtn={true} sectionSequence={0} title={backToLabel} programContainer={programContainer}
                            isEng={this.props.isEng} isTechicalErrorPage={true}
                            callback={(currentStep) => { this.setState({ stepperIndex: currentStep }) }}>
                        </StepIndicator>
                    )}
                </div>

                <div>
                    <ErrorAlertComponent 
                        title={this.props.isEng ? "There is a problem"
                            : "Il y a un problème"}
                        bodyMsg={body}
                        isEng={this.props.isEng} Visible={true} />
                </div>

                {/* <DynamicComponentRenderer componentName={componentName} componentProps={{props}}/> */}
                <div>
                    {reactElement}
                </div>        
                <p></p>
                <div>
                    <div>
                        <button className="ontario-button ontario-button--primary" onClick={() => {
                            window.location.replace(backToUrl);
                        }}>
                            {backToLabel}
                        </button>
                    </div> <p></p>

                    <div>
                        <FeedbackComponent programContainer={programContainer} isEng={this.props.isEng} field={this.props.field} status="400" code={this.props.field.feedback?.code || this.props.code}></FeedbackComponent>
                    </div>

                </div>

            </div>
        )

    }
}